import { render } from "./warehouse-modal.vue?vue&type=template&id=318d8f97&scoped=true"
import script from "./warehouse-modal.vue?vue&type=script&lang=js"
export * from "./warehouse-modal.vue?vue&type=script&lang=js"

import "./warehouse-modal.vue?vue&type=style&index=0&id=318d8f97&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-318d8f97"]])

export default __exports__